import { Divider, Stack, Typography } from '@mui/material';
import { FunnelDays } from 'features/co-pilot/co-pilot.types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import WorkDaysSelect from './work-days-select';
import WorkHoursSelect from './work-hours-select';

interface Props {
  workDays: FunnelDays[];
  workHours: number[];
  variant?: 'background' | 'border';

  handleWorkDaysChange(value: FunnelDays): () => void;

  handleWorkHoursChange(value: number): () => void;
}

const WorkTimeSettings: React.FC<Props> = ({ workDays, workHours, handleWorkDaysChange, handleWorkHoursChange, variant = 'background' }) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  return (
    <Stack className={cx(classes.workTimeSettings, variant === 'border' && classes.border)} gap={2.5}>
      <div>
        <Typography className={classes.subTitle} mb={'8px'}>
          {t('eligibleDays')}
        </Typography>
        <Typography className={classes.greyText} mb={'12px'}>
          {t('selectDaysActive')}
        </Typography>
        <WorkDaysSelect workDays={workDays} handleWorkDaysChange={handleWorkDaysChange} />
      </div>
      <Divider />
      <div>
        <Typography className={classes.subTitle} mb={'8px'}>
          {t('eligibleHours')}
        </Typography>
        <Typography className={classes.greyText} mb={'12px'}>
          {t('selectHoursActive')}
        </Typography>
        <WorkHoursSelect workHours={workHours} handleWorkHoursChange={handleWorkHoursChange} />
      </div>
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  workTimeSettings: {
    borderRadius: '12px',
    background: '#FFF',
    padding: '24px',
  },
  border: {
    border: `1px solid ${theme.palette.greys.light}`,
  },
  subTitle: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
  },
  greyText: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.greys.medium,
  },
}));

export default WorkTimeSettings;
